<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtit"><a id="page_vii"></a>L<span class="chsmall">IST OF</span> P<span class="chsmall">HOTOS AND</span> I<span class="chsmall">LLUSTRATIONS</span></h2>
<p class="fmp"><span href="#/xhtml/13_Chapter1#figure_1" title="Link target outside of Sample">The 1st New York Light Artillery</span></p>
<p class="fmp"><span href="#/xhtml/13_Chapter1#figure_2" title="Link target outside of Sample">A troop transport ship arriving in New Orleans</span></p>
<p class="fmp"><span href="#/xhtml/13_Chapter1#figure_3" title="Link target outside of Sample"><em class="italic">The City Belle</em> alongside the <em class="italic">Calypso</em></span></p>
<p class="fmp"><span href="#/xhtml/13_Chapter1#figure_4" title="Link target outside of Sample">Confederate troops attacking a Union gunboat during the Red River Campaign</span></p>
<p class="fmp"><span href="#/xhtml/16_Chapter4#figure_5" title="Link target outside of Sample">Union Prisoners at Camp Ford</span></p>
<p class="fmp"><span href="#/xhtml/16_Chapter4#figure_6" title="Link target outside of Sample">Federhen’s sketch of the stockade and mud houses at Camp Ford</span></p>
<p class="fmp"><span href="#/xhtml/16_Chapter4#figure_7" title="Link target outside of Sample">Prisoners and accommodations at Camp Ford</span></p>
<p class="fmp"><span href="#/xhtml/16_Chapter4#figure_8" title="Link target outside of Sample">Scenes from Camp Ford</span></p>
<p class="fmp"><span href="#/xhtml/16_Chapter4#figure_9" title="Link target outside of Sample">The sutler’s store at Camp Ford</span></p>
<p class="fmp"><span href="#/xhtml/16_Chapter4#figure_10" title="Link target outside of Sample">Federhen’s sketch of his quarters at Camp Ford</span></p>
<p class="fmp"><span href="#/xhtml/19_Chapter7#figure_11" title="Link target outside of Sample">Hounds chasing escaping Union prisoners in Texas</span></p>
<p class="fmp"><span href="#/xhtml/24_Chapter12#figure_12" title="Link target outside of Sample">James G. Bourland</span></p>
<p class="fmp"><span href="#/xhtml/27_Chapter15#figure_13" title="Link target outside of Sample">Henry E. McCulloch</span></p>
<p class="fmp"><span href="#/xhtml/29_Chapter17#figure_14" title="Link target outside of Sample">A settler’s hut on the Red River in Texas</span></p>
<p class="fmp"><span href="#/xhtml/30_Chapter18#figure_15" title="Link target outside of Sample">William Clarke Quantrill</span></p>
<p class="fmp"><span href="#/xhtml/31_Chapter19#figure_16" title="Link target outside of Sample">Bloody Bill Anderson</span></p>
<p class="fmp"><span href="#/xhtml/47_Chapter35#figure_17" title="Link target outside of Sample">Thomas W. Sherman</span></p>
<p class="fmp"><span href="#/xhtml/48_Chapter36#figure_18" title="Link target outside of Sample">Ormand F. Nims</span></p>
<p class="fmp"><span href="#/xhtml/50_Postscript#figure_19" title="Link target outside of Sample">Oscar Federhen’s grave</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_List_of_photos.vue?7d4cc338